function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViftoLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    fill: "#fe640b",
    d: "M 7.5,19.5 C 14.5,19.5 21.5,19.5 28.5,19.5C 33.985,32.4742 39.485,45.4742 45,58.5C 52.8055,40.084 60.8055,21.7506 69,3.5C 75.4438,2.19004 81.9438,2.19004 88.5,3.5C 76.9628,30.1211 65.6295,56.7877 54.5,83.5C 47.8002,83.83 41.1335,83.4967 34.5,82.5C 25.2122,61.5946 16.2122,40.5946 7.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    fill: "#1d88e4",
    d: "M 28.5,19.5 C 21.5,19.5 14.5,19.5 7.5,19.5C 6.59603,18.791 6.26269,17.791 6.5,16.5C 13.5316,16.1697 20.5316,16.503 27.5,17.5C 27.8627,18.1835 28.1961,18.8501 28.5,19.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViftoLogoSmall);
export default __webpack_public_path__ + "static/media/vifto-logo-small.67cc82d34c37c36ec3f256d894f69b5b.svg";
export { ForwardRef as ReactComponent };